module.exports = __webpack_public_path__ + "assets/08c7f36499fe0b9b77dc791dfc667b3e.svg";